import { Card } from "components/common";
import styled from "styled-components";

export const StyledLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 500px;
  width: 700px;
  min-height: 300px;
`;

export const StyledFormHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const StyledForm = styled.form`
  width: 500px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 4rem;

  > span {
    flex: 1;
  }
`;

export const StyledFormFooter = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex: 1;
`;
